import Typography from "@shared/v2/Typography";
import { useCurrentUser } from "../../reducers/layoutReducer/selectors";

interface TrainingResourceProps {
  action: React.ReactNode;
  description: React.ReactNode;
  icon: React.ReactNode;
  title: React.ReactNode;
}

const TrainingResource: React.FC<TrainingResourceProps> = ({ action, description, icon, title }) => {
  const currentUser = useCurrentUser() as { account: { isPlace: boolean } };
  return (
    <div className="tw-flex-1 tw-bg-white tw-border-solid tw-border-[2px] tw-border-gray-10 tw-rounded-[8px] tw-p-[16px] tw-flex tw-flex-col tw-gap-[16px] tw-min-w-[400px]">
      <div className="tw-flex tw-items-center tw-justify-between tw-gap-[8px]">
        <div className="tw-flex tw-gap-[16px] tw-items-center">
          <div
            className={`tw-flex-none tw-flex tw-items-center tw-justify-center tw-w-[40px] tw-h-[40px] tw-rounded-[4px] ${currentUser.account.isPlace ? "tw-bg-blue-50" : "tw-bg-brivity-blue-10"} tw-text-theme-primary`}
          >
            {icon}
          </div>
          {/* @ts-expect-error props */}
          <Typography variant="headline3">{title}</Typography>
        </div>
        {action}
      </div>
      {/* @ts-expect-error props */}
      <Typography className="!tw-text-gray-50">{description}</Typography>
    </div>
  );
};

export default TrainingResource;
